import { useMutation } from '@tanstack/react-query'
import { toast } from 'components/ui/use-toast'

import requests from 'service/api'
import { useAuth } from 'store/client/authStore'

export const useLogin = () => {

  const { setUser, setAccessToken } = useAuth()

  return useMutation({
    mutationFn: (data) => requests.auth.login(data),
    onSuccess: ({ data }) => {
      console.log("Login response:", data);
      setUser({
        id: data.id,
        mail: data.mail,
        tierType: data.tierType,
        companyName: data.companyName,
        companyId: data.companyId || null
      })
      setAccessToken(data.token)

    },
    onError: (error) => {
      toast.error(error.response.data.message)

    }
  })
}
